import { findApiGroupList, findApiListByGroupId,findApiInfoById,findApiParamsById,findApiReturnDataById } from '@/service/api';
import { IAPI } from '@/typings/apiManage';
import { IAPIBaseInfo, IAPIParam, IAPIReturnParamTree, IDocGroupTree, IDocState } from '@/typings/doc';
import { Module } from "vuex";
import { IGlobalState } from "..";
import * as Types from '../action-types';

const state: IDocState = {
    groupTree: [],
    apis: [],
    apiDetail: {
        apiBaseInfo: {
            id: "",
            title: "",
            introduce: "",
            description: "",
            url: "",
            version: "",
            returnExample: ""
        },
        apiParams: [],
        apiReturnParams: []
    }
};

const apiManage: Module<IDocState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_DOC_GROUP_LIST](state, payload: IDocGroupTree[]) {
            state.groupTree = payload;
        },
        [Types.SET_DOC_API_LIST](state, payload: IAPI[]) {
            state.apis = payload;
        },
        [Types.SET_DOC_API_INFO](state, payload: IAPIBaseInfo) {
            state.apiDetail.apiBaseInfo = payload;
        },
        [Types.SET_DOC_API_PARAMS](state, payload: IAPIParam []) {
            state.apiDetail.apiParams = payload;
        },
        [Types.SET_DOC_API_RETURN_PARAMS](state, payload: IAPIReturnParamTree []) {
            state.apiDetail.apiReturnParams = payload;
        }
    },
    actions: {
        // 设置文档接口分组菜单树
        async [Types.SET_DOC_GROUP_LIST]({ commit }, params) {
            let result = await findApiGroupList(params);
            commit(Types.SET_DOC_GROUP_LIST, result.data);
        },
        // 设置接口列表
        async [Types.SET_DOC_API_LIST]({ commit }, params) {
            let result = await findApiListByGroupId(params);
            commit(Types.SET_DOC_API_LIST, result.data);
        },
        // 设置接口详情
        async [Types.SET_DOC_API_INFO]({ commit }, params) {
            let result = await findApiInfoById(params);
            commit(Types.SET_DOC_API_INFO, result.data);
        },
        // 设置接口参数
        async [Types.SET_DOC_API_PARAMS]({ commit }, params) {
            let result = await findApiParamsById(params);
            commit(Types.SET_DOC_API_PARAMS, result.data);
        },
        // 设置接口返回参数
        async [Types.SET_DOC_API_RETURN_PARAMS]({ commit }, params) {
            let result = await findApiReturnDataById(params);
            commit(Types.SET_DOC_API_RETURN_PARAMS, result.data);
        }
    }
};
export default apiManage;